export const PackageStatus = {
    CURRENT_INDUCTED: "CURRENT_INDUCTED",
    CURRENT_STOWED: "CURRENT_STOWED",
    STOWED: "STOWED",
    CURRENT_RECEIVED: "CURRENT_RECEIVED",
    PROBLEM_SOLVE: "PROBLEM_SOLVE",
    PICKED: "PICKED",
    CURRENT_STOW_BUFFERED: "CURRENT_STOW_BUFFERED",
    CURRENT_MFR_JACKPOT_BUFFERED: "CURRENT_MFR_JACKPOT_BUFFERED",
    RESCHEDULED: "RESCHEDULED"
}

export const metricType = {
    COUNT: "count",
    TIME: "time"
};

export const Capability = {
    AMZL: "AMZL_CORE",
    SSD: "SSD",
    AR_NEXT_GEN: "AR_NEXT_GEN",
    AR: "AR"
};

export const Resource = {
    CLUSTER: "CLUSTER",
    AISLE: "AISLE",
    BIN: "BIN",
    ZONE: "ZONE",
    CART: "CART",
    CART_LOCATION: "CART_LOCATION",
    FLOOR: "FLOOR",
    FLOOR_LOCATION: "FLOOR_LOCATION",
    FLOOR_LOCATION_V2: "FLOOR_LOCATION_V2",
    STATION_PAIR: "STATION_PAIR",
    FLOOR_AND_SIDELINE_UNTIL_TIME: "FLOOR_AND_SIDELINE_UNTIL_TIME"
}

export const AtRiskAislesMetric = {
    MINUTES_OF_WORK: "MINUTES_OF_WORK",
    ADJACENCY_SCORE: "ADJACENCY_SCORE",
}

export const StowPackageMetric = {
    STOW_RATE: "STOW_RATE",
    LAST_FIFTEEN_MINUTE_STOW_RATE: "LAST_FIFTEEN_MINUTE_STOW_RATE",
    MINUTES_OF_WORK: "MINUTES_OF_WORK",
    SCAN_COMPLIANCE: "SCAN_COMPLIANCE",
    PROBLEM_SOLVE_COUNT: "PROBLEM_SOLVE_COUNT",
    STOWED_COUNT: "STOWED_COUNT",
    CURRENT_STOWED_COUNT: "CURRENT_STOWED_COUNT",
    CURRENT_INDUCTED_COUNT: "CURRENT_INDUCTED_COUNT",
    CURRENT_STOW_BUFFERED_COUNT: "CURRENT_STOW_BUFFERED_COUNT",
    CURRENT_MFR_JACKPOT_BUFFERED_COUNT: "CURRENT_MFR_JACKPOT_BUFFERED_COUNT",
    PLANNED_COUNT: "PLANNED_COUNT",
    STOW_VS_PLAN: "STOW_VS_PLAN",
    FSAF: "FSAF",
    CURRENT_SCAN_COMPLIANCE: "CURRENT_SCAN_COMPLIANCE",
    RESCHEDULED_COUNT: "RESCHEDULED_COUNT",
}

export const AssociateMetric = {
    ACTIVE_ASSOCIATE_COUNT: "ACTIVE_ASSOCIATE_COUNT",
    INACTIVE_ASSOCIATE_COUNT: "INACTIVE_ASSOCIATE_COUNT"
}

export const InductPackageMetric = {
    CUMULATIVE_INDUCTED: "CUMULATIVE_INDUCTED",
    INDUCTED_AT_STATION: "INDUCTED_AT_STATION",
    PENDING_INDUCT: "PENDING_INDUCT",
    RECEIVED: "RECEIVED",
    INDUCTED: "INDUCTED"
}

export const FloorMetric = {
    FLOORS_COUNT_MISSING_CART: "FLOORS_COUNT_MISSING_CART",
    ATTACHED_CART_COUNT: "ATTACHED_CART_COUNT"
}

export const FloorData = {
    FLOOR_LABEL: "FLOOR_LABEL",
    ROUTE_CODE: "ROUTE_CODE",
    ROUTE_ID: "ROUTE_ID",
    CART_DATA: "CART_DATA"
}

export const CartData = {
    CART_LABEL: "CART_LABEL",
    BIN_DATA: "BIN_DATA"
}

export const BinMetric = {
    BINS_COUNT_MISSING_OPEN_BAG: "BINS_COUNT_MISSING_OPEN_BAG"
}

export const BagMetric = {
    USED_BAG_COUNT: "USED_BAG_COUNT",
    PLANNED_BAG_COUNT: "PLANNED_BAG_COUNT",
    OPEN_BAG_COUNT: "OPEN_BAG_COUNT",
    CLOSED_BAG_COUNT: "CLOSED_BAG_COUNT"
}

export const CartMetric = {
    USED_CART_COUNT: "USED_CART_COUNT",
    PLANNED_CART_COUNT: "PLANNED_CART_COUNT",
    OPEN_CART_COUNT: "OPEN_CART_COUNT",
    CLOSED_CART_COUNT: "CLOSED_CART_COUNT",
    MISSING_CART_COUNT: "MISSING_CART_COUNT"
}

export const HeatMapView = {
    CLUSTER_VIEW: "clusterView",
    AISLE_VIEW: "aisleView",
    SORT_ZONE_VIEW: "sortZoneView",
    STATION_PAIR_VIEW: "stationPairView",
    FLOOR_VIEW: "floorView",
    ROUTE_VIEW: "routeView",
    ZONE_VIEW: "zoneView",
    CART_LOCATION_VIEW: "cartLocationView",
    FLOOR_LOCATION_VIEW: "floorLocationView",
    FLOOR_LOCATION_V2_VIEW: "floorLocationV2View",
    CART_VIEW: "cartView"
}

export const ViewType = {
    DEFAULT_VIEW: "defaultView",
    ROUTE_VIEW: "routeView",
    SIDELINE_VIEW: "sidelineView",
    REVERSE_SORT_GROUP_PLAN_VIEW: "reverseSortGroupPlanView"
}

export const CartType = {
    NORMAL: "NORMAL",
    HYBRID: "HYBRID",
    OV: "OV"
};

export const FileType = {
    CSV: "CSV",
    JSON: "JSON"
};

export const RangeFilter = {
    DIMENSION: "dimension",
    LESS_THAN_EQUAL: "lessThanEqual",
    LESS_THAN: "lessThan",
    GREATER_THAN: "greaterThan",
    GREATER_THAN_EQUAL: "greaterThanEqual"
};

export const NodeResourceData =  {
    NODE_RESOURCE_TYPE : "nodeResourceType",
    NODE_RESOURCE_LIST : "nodeResourceList"
};


// WEBPACK FOOTER //
// ./src/enums.js